/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_QuestionsInputs */

const en__field_questions = /** @type {(inputs: _Field_QuestionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which questions do you want to discuss with your mentor`)
};

const de__field_questions = /** @type {(inputs: _Field_QuestionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Fragen möchtest du mit deinem Mentor/ deiner Mentorin besprechen?`)
};

/**
* | output |
* | --- |
* | "Which questions do you want to discuss with your mentor" |
*
* @param {_Field_QuestionsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_questions = /** @type {((inputs?: _Field_QuestionsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_QuestionsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_questions(inputs)
	return de__field_questions(inputs)
});